<script>
	import { teamUrl } from './shared.js';

	export let standings = [];
	export let tag = '';
	export let compId = '';

	$: rows = [...(standings || [])].sort((a, b) => (a?.place ?? 999) - (b?.place ?? 999));

	function toNumber(value) {
		return Number.isFinite(Number(value)) ? Number(value) : 0;
	}

	function getTeamName(team) {
		return team?.shortName || team?.abcName || team?.name || '—';
	}

	function getWinPercent(team) {
		const games = toNumber(team?.totalGames);
		const wins = toNumber(team?.totalWin);
		if (!games) return 0;
		return Math.round((wins / games) * 100);
	}

	function getDifference(team) {
		return toNumber(team?.totalGoalPlus) - toNumber(team?.totalGoalMinus);
	}

	function getScoreResult(score, teamId) {
		if (!score || !teamId) return null;
		const winTeam = toNumber(score?.winTeam);
		if (!winTeam) return null;

		const normalizedTeamId = String(teamId);
		const team1Id = score?.team1Id != null ? String(score.team1Id) : null;
		const team2Id = score?.team2Id != null ? String(score.team2Id) : null;

		if (team1Id === normalizedTeamId) return winTeam === 1;
		if (team2Id === normalizedTeamId) return winTeam === 2;
		return null;
	}

	function getLastFive(team) {
		const scores = Array.isArray(team?.scores) ? team.scores : [];
		return scores.slice(-5).map((score) => getScoreResult(score, team?.teamId));
	}
</script>

<div class="filter__wrap">
	<div class="table__wrap">
		<table class="table">
			<thead>
				<tr>
					<th>Место</th>
					<th>Команда</th>
					<th>И</th>
					<th>В</th>
					<th>П</th>
					<th>%</th>
					<th>Последние 5 игр</th>
					<th>Забито</th>
					<th>Пропущено</th>
					<th>+/-</th>
					<th>Очки</th>
				</tr>
			</thead>
			<tbody>
				{#if rows.length}
					{#each rows as team}
						<tr>
							<td>{team?.place ?? '—'}</td>
							<td>
								<a class="table__item table__item-link" href={teamUrl(team?.teamId, { tag, compId })}>
									{#if team?.logo}
										<img src={team.logo} alt={getTeamName(team)} class="table__logo">
									{/if}
									<span>{getTeamName(team)}</span>
								</a>
							</td>
							<td>{toNumber(team?.totalGames)}</td>
							<td>{toNumber(team?.totalWin)}</td>
							<td>{toNumber(team?.totalDefeat)}</td>
							<td>{getWinPercent(team)}</td>
							<td>
								<div class="standings__streak">
									{#each getLastFive(team) as isWin}
										<span class="standings__dot {isWin === true ? '--win' : ''}"></span>
									{/each}
								</div>
							</td>
							<td>{toNumber(team?.totalGoalPlus)}</td>
							<td>{toNumber(team?.totalGoalMinus)}</td>
							<td>{getDifference(team)}</td>
							<td><b>{toNumber(team?.totalPoints)}</b></td>
						</tr>
					{/each}
				{:else}
					<tr>
						<td colspan="11">Нет данных для отображения</td>
					</tr>
				{/if}
			</tbody>
		</table>
	</div>
</div>

<style>
	.table__item-link {
		color: inherit;
		text-decoration: none;
	}
	.table__item-link:hover {
		text-decoration: underline;
	}
</style>
